"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const malty_atoms_button_1 = require("@carlsberggroup/malty.atoms.button");
const malty_atoms_headline_1 = require("@carlsberggroup/malty.atoms.headline");
const malty_atoms_icon_1 = require("@carlsberggroup/malty.atoms.icon");
const malty_atoms_overlay_1 = require("@carlsberggroup/malty.atoms.overlay");
const malty_icons_close_1 = __importDefault(require("@carlsberggroup/malty.icons.close"));
const malty_theme_malty_theme_provider_1 = require("@carlsberggroup/malty.theme.malty-theme-provider");
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const Modal_styled_1 = require("./Modal.styled");
const Modal_types_1 = require("./Modal.types");
const Modal = ({ open, onClose, content, title, dismissible = true, actions, size = Modal_types_1.ModalSize.Medium, whiteBackground = false }) => {
    const closeModal = () => {
        onClose();
    };
    const theme = (0, react_1.useContext)(styled_components_1.ThemeContext) || malty_theme_malty_theme_provider_1.globalTheme;
    return (react_1.default.createElement(react_1.default.Fragment, null, open ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(malty_atoms_overlay_1.Overlay, { isWhite: whiteBackground }),
        react_1.default.createElement(Modal_styled_1.StyledContainer, null,
            react_1.default.createElement(Modal_styled_1.StyledModalWrapper, { theme: theme, size: size },
                dismissible && (react_1.default.createElement(Modal_styled_1.StyledCloseIconContainer, { onClick: closeModal, theme: theme },
                    react_1.default.createElement(malty_icons_close_1.default, { size: malty_atoms_icon_1.IconSize.Medium, color: malty_atoms_icon_1.IconColor.DigitalBlack }))),
                title && (react_1.default.createElement(Modal_styled_1.StyledTitleContainer, { theme: theme },
                    react_1.default.createElement(malty_atoms_headline_1.Headline, { align: malty_atoms_headline_1.HeadlineAlign.Left, headlineStyle: malty_atoms_headline_1.HeadlineStyle.Large }, title))),
                react_1.default.createElement(Modal_styled_1.StyledContentContainer, { theme: theme }, content),
                actions && Array.isArray(actions) ? (react_1.default.createElement(Modal_styled_1.StyledButtonsWrapper, { theme: theme }, actions.map((btnInstance, index) => (react_1.default.createElement(Modal_styled_1.StyledButtonContainer, { theme: theme, key: btnInstance.key || `button${index}` },
                    react_1.default.createElement(malty_atoms_button_1.Button, { fullWidth: true, size: malty_atoms_button_1.ButtonSize.Large, style: malty_atoms_button_1.ButtonStyle[btnInstance.variant], onClick: btnInstance.onClick }, btnInstance.label)))))) : (actions))))) : null));
};
exports.Modal = Modal;
//# sourceMappingURL=Modal.js.map